'use client';
export default function InfoQualifiedSection() {
  return (
    <section
      id="info-6"
      className="relative overflow-hidden"
      style={{ backgroundColor: '#0e5932', minHeight: '420px' }}
    >
      {/* Background image on left */}
      <div
        className="absolute inset-y-0 left-0 hidden lg:block"
        style={{
          width: '50%',
          backgroundImage: 'url(https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=800&q=80)',
          backgroundSize: 'cover',
          backgroundPosition: 'center top',
        }}
      >
        <div className="absolute inset-0" style={{ background: 'rgba(14,89,50,0.3)' }} />
      </div>
      <div className="max-w-7xl mx-auto px-4 py-20 relative z-10">
        <div className="flex justify-end">
          <div className="w-full lg:w-1/2 lg:pl-12">
            <span className="block text-xs font-bold uppercase tracking-widest mb-3" style={{ color: '#fbaf45' }}>
              Médecins Qualifiés
            </span>
            <h3 className="text-3xl md:text-4xl font-black mb-8 text-white" style={{ fontFamily: 'Lato, sans-serif' }}>
              Une Équipe Médicale Experte et Pluridisciplinaire
            </h3>

            {[
              'Notre modèle d\'organisation repose sur une équipe agile et pluridisciplinaire, avec des spécialistes en médecine générale, pédiatrie, gynécologie, radiologie, diabétologie, ophtalmologie, fibroscopie et ORL.',
              'En fonction du positionnement et des services proposés, une évaluation claire est faite afin d\'identifier le nombre de personnel nécessaire pour assurer la rentabilité du centre et délivrer une qualité conforme aux standards fixés.',
              'Nous nous engageons à former continuellement notre personnel pour maintenir un haut niveau de compétence et assurer une bonne prise en charge des patients, conformément aux meilleures pratiques internationales.',
            ]?.map((text, i) => (
              <div key={i} className="flex items-start gap-3 mb-4">
                <i className="fas fa-genderless mt-1 flex-shrink-0" style={{ color: 'rgba(255,255,255,0.6)' }}></i>
                <p className="text-sm m-0" style={{ color: 'rgba(255,255,255,0.85)' }}>{text}</p>
              </div>
            ))}

            <a
              href="#doctors-1"
              className="inline-block mt-6 border-2 border-white text-white px-7 py-3 rounded font-bold text-sm uppercase tracking-wide transition-all"
              style={{ letterSpacing: '0.5px' }}
              onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#fff'; e.currentTarget.style.color = '#0e5932'; }}
              onMouseLeave={e => { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.color = '#fff'; }}
            >
              Nos Spécialités
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
